import React from 'react';
import {
  StatsBannerGrid,
  StatsBannerCard,
  StatsBannerNumber,
  StatsBannerHeadline,
  StatsBannerSubtext
} from 'routes/App/discountsV2/RecommendedDiscounts/DiscountsStatsBanner/styles';

// Static marketing copy from the design (GROW-2160). These figures are
// product/marketing claims, not API-driven metrics. Do not wire them up
// to live stats without product sign-off.
const STATS = [
  {
    number: '7x',
    headline: 'Return on every discount dollar',
    subtext: 'Discounts drive 7x their cost in revenue'
  },
  {
    number: '+45%',
    headline: 'Higher Average Order Value',
    subtext: 'Customers spend more when using a discount'
  },
  {
    number: '2x',
    headline: 'More likely to come back',
    subtext: 'Discount users repeat at nearly twice the rate'
  }
];

const DiscountsStatsBanner = () => (
  <StatsBannerGrid>
    {STATS.map((stat) => (
      <StatsBannerCard key={stat.number}>
        <StatsBannerNumber>{stat.number}</StatsBannerNumber>
        <StatsBannerHeadline>{stat.headline}</StatsBannerHeadline>
        <StatsBannerSubtext>{stat.subtext}</StatsBannerSubtext>
      </StatsBannerCard>
    ))}
  </StatsBannerGrid>
);

export default DiscountsStatsBanner;
